
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const OverviewContent = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Datenschutz auf einen Blick</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-sm text-joerg-600">
        <div className="bg-joerg-50 p-4 rounded-lg">
          <p className="leading-relaxed font-medium text-joerg-700">
            <strong>Geltungsbereich:</strong> Diese Datenschutzerklärung gilt für das Internetangebot von Jörg Hörmann unter der Domain joerg-hoermann.de sowie alle zugehörigen Subdomains (z.&nbsp;B. hochsensible-fuehrung.joerg-hoermann.de, reflexionen-zen.joerg-hoermann.de).
          </p>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Allgemeine Hinweise</h4>
          <p className="leading-relaxed">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
          </p>
        </div>

        <div className="bg-joerg-50 p-4 rounded-lg">
          <h4 className="font-medium text-joerg-700 mb-2">🔒 Privacy by Design</h4>
          <p className="leading-relaxed">
            Diese Website verzichtet bewusst auf zustimmungspflichtige Cookies, Tracking-Tools und Analyse-Dienste. Es werden keine Daten an Drittanbieter-Tracker oder Analyse-Tools übermittelt. Schriftarten (Fonts) werden lokal gehostet – es besteht keine Verbindung zu Google Fonts-Servern. Daher ist kein Cookie-Einwilligungsbanner erforderlich.
          </p>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Datenerfassung auf dieser Website</h4>
          <p className="leading-relaxed">
            <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
          </p>
          <p className="leading-relaxed mt-2">
            <strong>Wie erfassen wir Ihre Daten?</strong><br />
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.&nbsp;B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
            Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.&nbsp;B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
          </p>
          <p className="leading-relaxed mt-2">
            <strong>Wofür nutzen wir Ihre Daten?</strong><br />
            Die Daten werden ausschließlich erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Eine darüber hinausgehende Analyse des Nutzerverhaltens findet nicht statt.
          </p>
          <p className="leading-relaxed mt-2">
            <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default OverviewContent;
